/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';

import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';
import ProductBadge from '@components/global/ProductBadge';

import { fullWidth } from '@global/screens';
import { currency, hasProductBadge } from '@global/helpers';

import Colors from '@global/colors';

import PropTypes from 'prop-types';

const propTypes = {
  data: PropTypes.object,
  onCallback: PropTypes.func,
  extraInfo: PropTypes.string,
};

const defaultProps = {
  data: {},
  onCallback: {},
  extraInfo: '',
};

const ProductItemMobile = ({ data, onCallback = () => {}, extraInfo = '' }) => {
  const productTextWidth = hasProductBadge(data)
    ? fullWidth - 90
    : fullWidth - 20;

  return (
    <TouchableOpacity
      activeOpacity={0.6}
      style={[styles.productItem, data.style]}
      onPress={() => onCallback(data)}>
      <View
        style={{
          width: productTextWidth,
          flexDirection: 'row',
        }}>
        <Image
          style={{ width: 50, height: 50, marginRight: 10 }}
          width={50}
          height={50}
          compressWidth={50}
          source={data.image}
        />
        <View
          style={{
            width: productTextWidth - 60,
          }}>
          <SociollaText
            type="medium"
            style={{ fontSize: 13, width: productTextWidth - 60 }}>
            [{data.reference ? data.reference : '-'}]
          </SociollaText>
          <SociollaText
            style={{
              fontSize: 14,
              marginVertical: 5,
              width: productTextWidth - 60,
            }}>
            {data.name ? data.name : '-'}
          </SociollaText>
          {extraInfo ? (
            <SociollaText
              style={{
                fontSize: 12,
                marginBottom: 4,
                color: Colors.grey2,
                width: productTextWidth - 60,
              }}>
              {extraInfo}
            </SociollaText>
          ) : (
            false
          )}
          <SociollaText
            type="medium"
            style={{ fontSize: 13, width: productTextWidth - 60 }}>
            {data.price ? currency(data.price, true) : '-'}
          </SociollaText>
        </View>
      </View>
      <View style={{ width: hasProductBadge(data) ? 70 : 0 }}>
        {data.is_best_seller ? (
          <ProductBadge status="best" type="mini" style={{ marginBottom: 5 }} />
        ) : (
          false
        )}
        {data.is_promo ? (
          <ProductBadge
            status="promo"
            type="mini"
            style={{ marginBottom: 5 }}
          />
        ) : (
          false
        )}
        {data.is_new ? (
          <ProductBadge status="new" type="mini" style={{ marginBottom: 5 }} />
        ) : (
          false
        )}
      </View>
    </TouchableOpacity>
  );
};

ProductItemMobile.propTypes = propTypes;
ProductItemMobile.defaultProps = defaultProps;

const styles = StyleSheet.create({
  productItem: {
    width: fullWidth,
    paddingVertical: 13,
    paddingHorizontal: 10,
    backgroundColor: Colors.white,
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

export default React.memo(ProductItemMobile, (prev, next) => prev == next);
